import { Component, OnInit, TemplateRef } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { select, Store } from "@ngrx/store";
import { DetailsLpComponent } from "src/app/shared/components/details-modal/details-lp/details-lp.component";
import { DeleteComponent } from "src/app/shared/components/drop-zone-options/modal/delete/delete.component";
import { UpdateComponent } from "src/app/shared/components/drop-zone-options/modal/update/update.component";
import {
  ActionInterface,
  ActionReturned,
  createFranchise,
  createLocation,
  franchiseActions,
  locationActions,
  OptionActionEnum,
  updateFranchise,
  updateLocation,
} from "src/app/shared/data/actions-data";
import {
  FilterInterface,
  locationFilter,
} from "src/app/shared/data/filter-data";
import { FranchiseStatus } from "src/app/shared/enum/franchise-status.enum";
import {
  PartnerStatus,
  PartnerStatusToShow,
} from "src/app/shared/enum/partner-status";
import { PaymentFrequency } from "src/app/shared/enum/payment-frequency";
import { PricingMethod } from "src/app/shared/enum/pricing-method";
import { TypeCards } from "src/app/shared/enum/typeCards";
import { UserHistoryActionsEnum } from "src/app/shared/enum/userHistoryActions";
import { UserHistoryServicesEnum } from "src/app/shared/enum/userHistoryService";
import { FranchiseResultInterface } from "src/app/shared/models/franchise/franchise-result.interface";
import { LocationPartnerInterface } from "src/app/shared/models/location-partners/locationPartner.interface";
import { BadgeService } from "src/app/shared/services/badge.service";
import { SaveUserHistoryService } from "src/app/shared/services/history/saveHistory";
import { JwtService } from "src/app/shared/services/jwt.service";
import { AppStateInterface } from "src/app/store/appState.interface";
import {
  saveUpdateFields,
  updateFields,
} from "src/app/store/settings/settings.actions";
import { UtilFunctions } from "src/app/utils/utilFunctions";
import { FeaturesComponent } from "../features/features.component";
import { VouchersComponent } from "../vouchers/vouchers.component";
import { ApiKeyComponent } from "src/app/shared/components/api-key/api-key.component";
import { UpdatePasswordComponent } from "src/app/shared/components/drop-zone-options/modal/update-password/update-password.component";
import { invokeAllAvailableFeatures } from "src/app/store/features/features.actions";
import { Authorities } from "src/app/shared/enum/authorities";
import { OptionActionInterface } from "src/app/shared/models/option-action.interface";
import { FranchiseProfileInterface } from "src/app/shared/models/franchise/franchise-profile.interface";
import { Observable, takeUntil } from "rxjs";
import { BaseComponent } from "src/app/base.component";
import {
  franchiseResultSelector,
} from "src/app/store/franchise/franchise.selectors";
import { invokeApiDistroyed } from "src/app/store/apiState.interface";
import {
  invokeFranchiseFilter,
} from "src/app/store/franchise/franchise.action";
import { LocationPartnersFilterInterface } from "src/app/shared/models/location-partners/locationPartnersFilter.interface";
import { initialState } from "src/app/store/franchise/franchise.reducers";
import { Constants } from "src/app/shared/data/constants";
import { selectedSubCategoriesSelector } from "src/app/store/subCategory/subCategory.selectors";
import { saveSelectedZonesSelector } from "src/app/store/zone/zone.selectors";
import { saveSelectedZone } from "src/app/store/zone/zone.actions";
import { saveSelectedRegionSelector } from "src/app/store/region/region.selectors";
import { saveSelectedRegion } from "src/app/store/region/region.actions";
import { FilterParams } from "src/app/shared/models/filterParams";
import { FiltersService } from "src/app/shared/services/filters.service";
import { TranslateService } from "@ngx-translate/core";
import { saveAs } from "file-saver";
import { DeleteFranchiseComponent } from "./delete-franchise/delete-franchise.component";
import { SuccessDto } from "src/app/shared/models/success-dto";
import { locationPartnerCreatedSelector, locationPartnerDeletedByEmailSelector } from "src/app/store/locationPartner/location-partner.selectors";
import { createLocationPartnerSuccess, deleteLocationPartnerSuccess } from "src/app/store/locationPartner/location-partner.action";
import { UserStatus, UserStatusEnumMapping } from "src/app/shared/enum/user-status";
import { resultArchiveUserSelector } from "src/app/store/user/user.selectors";
import { invokeLocationPartners } from "src/app/store/locationPartner/actions/get-locations.actions";
import { invokeArchiveUser, resultArchiveUser } from "src/app/store/user/user.actions";
import { ToastrService } from "ngx-toastr";
import { ConfirmationModalComponent } from "src/app/shared/components/modal/confirmation-modal/confirmation-modal.component";

@Component({
  selector: "app-franchise-list",
  templateUrl: "./franchise-list.component.html",
  styleUrls: ["./franchise-list.component.scss"],
})
export class FranchiseListComponent extends BaseComponent implements OnInit {
  deletedIsLoading: any;
  forbidden: any;

  selectedSubCategories$: Observable<string[] | null>;
  selectedSubCategories: string[];
  selectedZones$: Observable<string[] | null>;
  selectedZones: string[] = [];
  selectedRegion: string[] = [];
  selectedRegion$: Observable<string[] | null>;

  franchiseResult: FranchiseResultInterface = {
    count: 0,
    franchises: [],
  };

  pageSize: number = 5;
  pageNumber: number = 1;

  optionSelected: PartnerStatus | null;
  franchiseResult$: Observable<FranchiseResultInterface | null>;
  franchiseFilter: LocationPartnersFilterInterface = {
    ...initialState.franchiseFilter,
    pager: {
      pageSize: this.pageSize,
      pageNumber: this.pageNumber,
    },
  };

  loading: any;

  isAuthorised: any;
  zones: string[] = [];

  formFilter: FormGroup<any>;
  paymentFrequencyToShow = PaymentFrequency;
  pricingMethod = PricingMethod;
  locationOptions: ActionInterface[] = locationActions;
  franchiseOptions: ActionInterface[] = franchiseActions;
  updateLocation: ActionInterface[] = updateLocation;
  createLocation: ActionInterface[] = createLocation;
  updateFranchise: ActionInterface[] = updateFranchise;
  createFranchise: ActionInterface[] = createFranchise;
  update: OptionActionInterface = {
    name: [],
    icon: [],
    optionSelected: null,
    title: "",
  };

  filters: FilterParams | null = null;
  previouslySelectedSubCategories: string[] = [];

  resultDeleteLocation$: Observable<SuccessDto | null>;

  userStatus = UserStatus;

  userStatusEnumMapping = UserStatusEnumMapping;

  resultArchiveUser$: Observable<SuccessDto | null>;
  archiveModal: NgbModalRef;

  locationCreated$: Observable<SuccessDto | null>;
  
  constructor(
    private store: Store<AppStateInterface>,
    private fb: FormBuilder,
    public badgeService: BadgeService,
    private modalService: NgbModal,
    private saveHistory: SaveUserHistoryService,
    private jwtService: JwtService,
    private filtersService: FiltersService,
    private translate: TranslateService,
    private toastr: ToastrService,
  ) {
    super(store);

    this.formFilter = this.fb.group({
      companyName: [""],
    });
    const authorities = this.jwtService.getPermissions(jwtService.getToken());
    if (authorities) {
      this.isAuthorised = authorities.includes(
        Authorities.LP_CREATE.toString()
      );
      this.forbidden = !authorities.includes(Authorities.LP_GETALL.toString());
    }

    this.franchiseResult$ = this.store
      .pipe(select(franchiseResultSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.selectedSubCategories$ = this.store
      .pipe(select(selectedSubCategoriesSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.selectedZones$ = this.store
      .pipe(select(saveSelectedZonesSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.selectedRegion$ = this.store
      .pipe(select(saveSelectedRegionSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.resultDeleteLocation$ = this.store
      .pipe(select(locationPartnerDeletedByEmailSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.resultArchiveUser$ = this.store
    .pipe(select(resultArchiveUserSelector))
    .pipe(takeUntil(this.ngDestroyed$));

    this.locationCreated$ = this.store
      .pipe(select(locationPartnerCreatedSelector))
      .pipe(takeUntil(this.ngDestroyed$));

    this.extractFilters();
  }

  ngOnInit(): void {
    this.filter.name.map(
      (e) =>
        (e.data = Object.keys(PartnerStatus)
          .filter((value) => isNaN(Number(value)) === true)
          .map(
            (key: string | any) =>
              PartnerStatusToShow[key as keyof typeof PartnerStatus]
          ))
    );

    this.resultArchiveUser$.subscribe((result) => {
      if (result) {
        if (result.message !== "UPDATE_USER_PASSWORD_SUCCESSFULLY_MESSAGE") {
          this.toastr.success(
            this.translate.instant("response.success." + result.message),
            this.translate.instant("response.successTitle")
          );
        }
        this.store.dispatch(resultArchiveUser({ successMessage: null }));
        this.loadData();
        this.archiveModal.close();
      }
    });

    this.store.dispatch(invokeAllAvailableFeatures());
    this.loadData();
    this.saveHistory.saveUserHistory(
      UserHistoryActionsEnum.GET,
      UserHistoryServicesEnum.FRANCHISE_LIST
    );

    this.franchiseResult$.subscribe(
      (result: FranchiseResultInterface | null) => {
        if (result != null) {
          this.franchiseResult = result;
          result.franchises.map((franchise) => {
            franchise.locations.map((value) => {
              this.zones.push(value.zoneName);
            });
          });
        }
      }
    );

    this.locationCreated$.subscribe((data) => {
      if (data) {
        this.toastr.success(
          this.translate.instant("response.success." + data.message),
          this.translate.instant("response.successTitle")
        );
        this.store.dispatch(
          createLocationPartnerSuccess({ successMessage: null })
        );
      }
    });

    this.selectedSubCategories$.subscribe((result) => {
      if (
        result &&
        JSON.stringify(result) !==
          JSON.stringify(this.previouslySelectedSubCategories)
      ) {
        this.selectedSubCategories = result;
        this.franchiseFilter.subcategories = result;
        this.loadData();
      }
    });

    this.selectedZones$.subscribe((data) => {
      if (data) {
        this.selectedZones = data;
        this.pageNumber = 1;
        this.franchiseFilter = {
          ...this.franchiseFilter,
          zoneNames: this.selectedZones,
          pager: {
            ...this.franchiseFilter.pager,
            pageNumber: this.pageNumber,
          },
        };
        this.loadData();
      }
    });

    this.selectedRegion$.subscribe((data) => {
      if (data) {
        this.pageNumber = 1;
        this.selectedRegion = data;
        this.franchiseFilter = {
          ...this.franchiseFilter,
          regions: this.selectedRegion,
          pager: {
            ...this.franchiseFilter.pager,
            pageNumber: this.pageNumber,
          },
        };
        this.loadData();
      }
    });

    this.formFilter.valueChanges.subscribe((value) => {
      this.pageNumber = 1;
      this.pageSize = Constants.defaultTableSize;
      this.franchiseFilter = {
        ...this.franchiseFilter,
        companyName: value.companyName,
        pager: {
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        },
      };
      this.loadData();
    });

    this.store.dispatch(saveSelectedZone({ selectedZones: null }));
    this.store.dispatch(saveSelectedRegion({ selectedRegion: null }));

    this.resultDeleteLocation$.subscribe((result) => {
      if (result) {
        this.loadData()
        this.store.dispatch(deleteLocationPartnerSuccess({successMessage : null}))
      }
      this.loading = false;
    });
  }


  //Pagination Config
  changePage(event: number) {
    this.pageNumber = event;
    this.franchiseFilter = {
      ...this.franchiseFilter,
      pager: {
        ...this.franchiseFilter.pager,
        pageNumber: this.pageNumber,
      },
    };
    this.loadData();
  }

  itemsPerPageChange(pageSize: number) {
    this.pageSize = pageSize;
    this.pageNumber = 1;
    this.franchiseFilter = {
      ...this.franchiseFilter,
      pager: {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      },
    };
    this.loadData();
  }

  onClickShowModal() {
    this.store.dispatch(saveUpdateFields({ options: this.createLocation }));
    this.store.dispatch(updateFields({ fields: this.update }));
    const modalRef = this.modalService.open(UpdateComponent, {
      centered: true,
    });
    modalRef.componentInstance.type = TypeCards.ADMIN_LOCATION_CREATE;
    modalRef.componentInstance.title = "addLP.title";
    modalRef.componentInstance.isFranchise = true;
  }

  findOption(option: string | null) {
    let filter: PartnerStatus | null = null;
    const KeyFound = Object.keys(PartnerStatusToShow).find(
      (key) => PartnerStatusToShow[key as PartnerStatus] === option
    );
    switch (KeyFound) {
      case PartnerStatus.INTERNET_PROVIDER_PAYMENT:
        filter = PartnerStatus.INTERNET_PROVIDER_PAYMENT;
        break;
      case PartnerStatus.REVENUE_SHARING:
        filter = PartnerStatus.REVENUE_SHARING;
        break;
      default:
        filter = null;
    }
    return filter;
  }
  saveOptionFilter(option: string | null) {
    this.pageNumber = 1;
    this.findOption(option);
    this.optionSelected = this.findOption(option);
    this.franchiseFilter = {
      ...this.franchiseFilter,
      partnerStatus: this.optionSelected,
      pager: {
        ...this.franchiseFilter.pager,
        pageNumber: 1,
      },
    };
    this.loadData();
  }

  filter: FilterInterface = locationFilter;
  convertToCsv() {
    const csvRows: string[] = [];
    const headers = [
      this.translate.instant("admin.locations.franchise.franchise"),
      this.translate.instant("admin.locations.franchise.franchised"),
      this.translate.instant("admin.locations.franchise.region"),
      this.translate.instant("admin.locations.franchise.zone"),
      this.translate.instant("admin.locations.franchise.categories"),
      this.translate.instant("admin.locations.franchise.subcategories"),
      this.translate.instant("admin.locations.franchise.tags"),
      this.translate.instant("admin.locations.franchise.option"),
      this.translate.instant("admin.locations.franchise.pilotPhaseEnd"),
      this.translate.instant("admin.locations.franchise.responsible"),
      this.translate.instant("admin.locations.franchise.email"),
      this.translate.instant("admin.locations.franchise.phone"),
      this.translate.instant("admin.locations.franchise.paymentMethod"),
      this.translate.instant("admin.locations.franchise.price"),
      this.translate.instant("admin.locations.franchise.paymentFrequency"),
      this.translate.instant("admin.locations.franchise.status"),
    ];
    this.franchiseResult.franchises.forEach((franchise) => {
      const franchiseRow = [franchise.franchise.companyName];
      franchise.locations.forEach((location, index) => {
        const franchisedRow = [
          location.companyName ?? this.translate.instant("undefined"),
          location.region ?? this.translate.instant("undefined"),
          location.zoneName ?? this.translate.instant("undefined"),
          location.category ?? this.translate.instant("undefined"),
          location.subCategories.join(" - ") ||
            this.translate.instant("undefined"),
          location.tags.join(" - ") || this.translate.instant("undefined"),
          this.translate.instant(
            "enumMapping.partnerStatus." + (location.partnerStatus ?? "NONE")
          ) ?? this.translate.instant("undefined"),
          location.pilotPhaseEndDate ?? this.translate.instant("undefined"),
          location.firstName ?? this.translate.instant("undefined"),
          location.email ?? this.translate.instant("undefined"),
          location.phone ?? this.translate.instant("undefined"),
          this.translate.instant(
            "enumMapping.paymentMethode." + (location.pricingMethod ?? "NONE")
          ),
          location.price ?? this.translate.instant("undefined"),
          this.translate.instant(
            "enumMapping.paymentFrequency." +
              (location.paymentFrequency ?? "NONE")
          ),
          this.translate.instant(
            "enumMapping.franchiseStatus." + this.getActiveStaus(location)
          ),
        ];
        if (index === 0) {
          franchiseRow[0] = `${franchiseRow[0]},${franchisedRow.join(",")}`;
        } else {
          franchiseRow.push(`,${franchisedRow.join(",")}`);
        }
      });
      csvRows.push(franchiseRow.join("\n"));
    });
    this.modalService.dismissAll();
    return [headers, ...csvRows].join("\n");
  }

  exportCSV(exportModal: any) {
    this.modalService.open(exportModal, {
      centered: true,
    });
  }
  exportToCSV() {
    this.loading = true;
    const csvData = this.convertToCsv();
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8" });
    saveAs(blob, `${this.translate.instant("exportLP.title")}.csv`);
  }

  getActiveStaus(location: LocationPartnerInterface): FranchiseStatus {
    return UtilFunctions.getFranchisedActiveStatus(location);
  }

  saveFranchiseOption(
    action: ActionReturned,
    franchise: FranchiseProfileInterface
  ) {
    switch (action.option.type) {
      case OptionActionEnum.ADMIN_FRANCHISE_DELETE: {
        const modal = this.modalService.open(DeleteFranchiseComponent, {
          centered: true,
          size: "lg",
        });
        modal.componentInstance.companyName = franchise.companyName;
        break;
      }
      case OptionActionEnum.ADMIN_FRANCHISE_DETAILS: {
        const modal = this.modalService.open(DetailsLpComponent, {
          centered: true,
          size: "lg",
        });
        modal.componentInstance.locationPartner =
          franchise as LocationPartnerInterface;
        modal.componentInstance.isFranchise = true;
        modal.componentInstance.title = "FranchiseOptions.details";
        modal.componentInstance.isFranchise = true;
        this.saveHistory.saveUserHistory(
          UserHistoryActionsEnum.GET,
          UserHistoryServicesEnum.FRANCHISE_DETAILS
        );
        break;
      }
      case OptionActionEnum.ADMIN_FRANCHISE_UPDATE: {
        this.store.dispatch(
          saveUpdateFields({ options: this.updateFranchise })
        );
        const modal = this.modalService.open(UpdateComponent, {
          centered: true,
        });
        modal.componentInstance.type = TypeCards.ADMIN_FRANCHISE_UPDATE;
        modal.componentInstance.isCol4 = false;
        modal.componentInstance.title = "FranchiseOptions.update";
        modal.componentInstance.email = franchise.email;
        modal.componentInstance.locationPartner = franchise;
        modal.componentInstance.isFranchise = true;
        break;
      }
      case OptionActionEnum.ADMIN_FRANCHISE_FEATURES: {
        const modal = this.modalService.open(FeaturesComponent, {
          centered: true,
        });
        modal.componentInstance.userEmail = franchise.email;
        modal.componentInstance.title = "FranchiseOptions.features";
        modal.componentInstance.companyName = franchise.companyName;
        modal.componentInstance.isFranchise = true;
        break;
      }
      case OptionActionEnum.ADMIN_FRANCHISE_UPDATE_PASSWORD: {
        const modal = this.modalService.open(UpdatePasswordComponent, {
          centered: true,
        });
        modal.componentInstance.companyName = franchise.companyName;
        modal.componentInstance.email = franchise.email;
        modal.componentInstance.closeTheModal.subscribe((value: boolean) => {
          if (value) {
            modal.close();
          }
        });
        break;
      }
      case OptionActionEnum.ADMIN_USER_ARCHIVE: {
        this.archiveOrActivateUser(
          franchise,
          "pop-ups_Message.confirmationModal.targets.locationPartner.actions.archive.title",
          "pop-ups_Message.confirmationModal.targets.locationPartner.actions.archive.label"
        );
        break;
      }

      case OptionActionEnum.ADMIN_USER_REACTIVATE: {
        this.archiveOrActivateUser(
          franchise,
          "pop-ups_Message.confirmationModal.targets.locationPartner.actions.reactivate.title",
          "pop-ups_Message.confirmationModal.targets.locationPartner.actions.reactivate.label"
        );
        break;
      }
    }
  }

  saveLocationOption(
    action: ActionReturned,
    location: LocationPartnerInterface
  ) {
    switch (action.option.type) {
      case OptionActionEnum.ADMIN_LOCATION_DELETE: {
        const modal = this.modalService.open(DeleteComponent, {
          centered: true,
        });
        modal.componentInstance.name = "pop-up.lp.title";
        modal.componentInstance.reference = location.email;
        modal.componentInstance.title = "LPOptions.delete";
        modal.componentInstance.type = OptionActionEnum.ADMIN_LOCATION_DELETE;
        break;
      }
      case OptionActionEnum.ADMIN_LOCATION_DETAILS: {
        const modal = this.modalService.open(DetailsLpComponent, {
          centered: true,
          size: "lg",
        });
        modal.componentInstance.locationPartner = location;
        modal.componentInstance.title = "LPOptions.details";
        this.saveHistory.saveUserHistory(
          UserHistoryActionsEnum.GET,
          UserHistoryServicesEnum.LOCATION_DETAILS
        );
        break;
      }
      case OptionActionEnum.ADMIN_LOCATION_UPDATE: {
        this.store.dispatch(saveUpdateFields({ options: this.updateLocation }));
        const modal = this.modalService.open(UpdateComponent, {
          centered: true,
          size: "xl",
        });
        modal.componentInstance.type = TypeCards.ADMIN_LOCATION_UPDATE;
        modal.componentInstance.isCol4 = false;
        modal.componentInstance.title = "LPOptions.update";
        modal.componentInstance.email = location.email;
        modal.componentInstance.locationPartner = location;
        modal.componentInstance.isMissingStatusData =location.partnerStatus === null ||
        (location.partnerStatus === PartnerStatus.REVENUE_SHARING && location.pilotPhaseEndDate === null) ||
        (location.partnerStatus === PartnerStatus.INTERNET_PROVIDER_PAYMENT && location.paymentFrequency === null)
        modal.componentInstance.isMissingRouterData =
          !location.sessionTimeoutInMinutes || !location.routerBrand;

        break;
      }
      case OptionActionEnum.ADMIN_LOCATION_FEATURES: {
        const modal = this.modalService.open(FeaturesComponent, {
          centered: true,
        });
        modal.componentInstance.userEmail = location.email;
        modal.componentInstance.title = "LPOptions.features";
        modal.componentInstance.companyName = location.companyName;
        modal.componentInstance.isFranchised = true;
        break;
      }
      case OptionActionEnum.ADMIN_LOCATION_VOUCHER: {
        const modal = this.modalService.open(VouchersComponent, {
          centered: true,
          size: "xl",
        });
        modal.componentInstance.locationPartnerEmail = location.email;
        modal.componentInstance.title = "LPOptions.voucher";
        modal.componentInstance.mode = "dialog";
        this.saveHistory.saveUserHistory(
          UserHistoryActionsEnum.GET,
          UserHistoryServicesEnum.VOUCHER_LIST
        );
        modal.componentInstance.closeTheModal.subscribe((value: boolean) =>
          modal.close()
        );
        break;
      }
      case OptionActionEnum.ADMIN_LOCATION_API_KEY: {
        const modal = this.modalService.open(ApiKeyComponent, {
          centered: true,
          size: "xl",
        });
        modal.componentInstance.email = location.email;
        modal.componentInstance.hideKey = true;
        break;
      }
      case OptionActionEnum.ADMIN_LOCATION_UPDATE_PASSWORD: {
        const modal = this.modalService.open(UpdatePasswordComponent, {
          centered: true,
        });
        modal.componentInstance.companyName = location.companyName;
        modal.componentInstance.email = location.email;
        modal.componentInstance.closeTheModal.subscribe((value: boolean) => {
          if (value) {
            modal.close();
          }
        });
        break;
      }
      
      case OptionActionEnum.ADMIN_USER_ARCHIVE: {
        this.archiveOrActivateUser(
          location,
          "pop-ups_Message.confirmationModal.targets.locationPartner.actions.archive.title",
          "pop-ups_Message.confirmationModal.targets.locationPartner.actions.archive.label"
        );
        break;
      }

      case OptionActionEnum.ADMIN_USER_REACTIVATE: {
        this.archiveOrActivateUser(
          location,
          "pop-ups_Message.confirmationModal.targets.locationPartner.actions.reactivate.title",
          "pop-ups_Message.confirmationModal.targets.locationPartner.actions.reactivate.label"
        );
        break;
      }

    }
  }

  extractFilters() {
    this.filters = this.filtersService.decodeUri();
    if (this.filters) {
      this.optionSelected = this.findOption(this.filters.status) ?? null;
      this.franchiseFilter.regions =
        this.filtersService.extractArrayValueFromUrl(
          this.filters,
          "regions",
          this.selectedRegion
        );
      this.franchiseFilter.zoneNames =
        this.filtersService.extractArrayValueFromUrl(
          this.filters,
          "zones",
          this.selectedZones
        );
    }
    this.pageNumber = this.filtersService.extractValueFromUrl(
      this.filters,
      "page",
      this.pageNumber
    );
    this.pageSize = this.filtersService.extractValueFromUrl(
      this.filters,
      "size",
      this.pageSize
    );

    this.filtersService.patchFormValue(
      this.filters,
      ["companyName"],
      this.formFilter
    );

    this.franchiseFilter = {
      ...this.franchiseFilter,
      companyName: this.formFilter.get("companyName")?.value,
      pager: {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      },
    };
  }

  // loadData() {
  //   this.store.dispatch(
  //     invokeFranchiseFilter({
  //       franchiseFilter: {
  //         ...this.locationPartnerFilter,
  //         partnerStatus: this.optionSelected,
  //       },
  //     })
  //   );
  // }

  loadData(){
    this.store.dispatch(invokeFranchiseFilter({franchiseFilter : {...this.franchiseFilter}}))
  }

  archiveOrActivateUser(
    user: LocationPartnerInterface | FranchiseProfileInterface,
    title: string,
    actionLabel: string
  ) {
    this.archiveModal = this.modalService.open(ConfirmationModalComponent, {
      centered: true,
    });
    this.archiveModal.componentInstance.title = title;
    this.archiveModal.componentInstance.actionLabel = actionLabel;
    this.archiveModal.componentInstance.targetType =
      "pop-ups_Message.confirmationModal.targets.locationPartner.label";
    this.archiveModal.componentInstance.targetName =
      user.companyName;
    this.archiveModal.componentInstance.confirmAction.subscribe(
      (value: boolean) => {
        if (value) {
          this.store.dispatch(
            invokeArchiveUser({ email: user.email })
          );
          this.saveHistory.saveUserHistory(
            UserHistoryActionsEnum.PATCH,
            UserHistoryServicesEnum.ADMIN_ARCHIVE_LOCATION_PARTNER
          );
        }
      }
    );
    this.archiveModal.componentInstance.closeModal.subscribe((value: boolean) =>
      this.archiveModal.close()
    );
  }

  getOptions(actions: ActionInterface[], archiveDate: Date | null): ActionInterface[] {
    return actions.filter((action) =>
      archiveDate
        ? action.type !== OptionActionEnum.ADMIN_USER_ARCHIVE
        : action.type !== OptionActionEnum.ADMIN_USER_REACTIVATE
    );
  }

  isCollaboratorArchived(archivedDate: Date | null): UserStatus {
    return UtilFunctions.isCollaboratorArchived(archivedDate);
  }
}
